﻿import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils";
import { queryKeys } from "../queryKeys";
import { CandidateSignature } from "../models/CandidateSignature";
import { validateUuid } from "../../utils";

export function useCandidateSignatures(tenantId: string | undefined, entityId: string | undefined, candidateId: string | undefined) {
    const axios = axiosInstance();
    return useQuery({
        ...queryKeys.candidateSignatures.byCandidateId(candidateId),
        queryFn: () =>
            axios
                .get<CandidateSignature[]>(
                    `api/Clients/${validateUuid(tenantId)}/entities/${validateUuid(entityId)}/candidates/${validateUuid(candidateId)}/signatures`
                )
                .then(response => response.data),
        enabled: !!tenantId && !!entityId && !!candidateId,
    });
}
